import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  isArchiveAuditModalOpen: boolean;
};

const initialState: InitialState = {
  isArchiveAuditModalOpen: false,
};

const generationSlice = createSlice({
  name: "audit-archive",
  initialState: initialState,

  reducers: {
    setArchiveAuditModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isArchiveAuditModalOpen = action.payload;
    },
  },
});

export default generationSlice.reducer;
export const { setArchiveAuditModalOpen } = generationSlice.actions;
